import {ChangeDetectorRef, Component, ElementRef, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  IonicPage,
  Loading,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  Popover,
  PopoverController,
  Select,
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {isUndefined} from "util";
import {AppConfigPage} from "../app-config/app-config";
import {
  COLOR_REPLENISHENT_MODULE,
  DEPARTMENT_NAME_ALL_VALUE,
  NAV_PARAM_AUTO_SEARCH,
  NAV_PARAM_RETURN_PAGE,
  RETURN_PAGE_REPLENISHMENT
} from "../../app/app.constants";
import {VizixService} from "../../providers/vizix.service";
import {StatusBar} from "@ionic-native/status-bar";
import {ReplenishmentModel} from "../../models/ReplenishmentModel";
import {FindItemPage} from "../find-item/find-item";
import {ReplenishmentService} from "../../providers/replenishment.service";
import {PopoverDetailsPage} from "../popover-details/popover-details";
import {FormatDataTypePipe} from "../../pipes/format-data-type/format-data-type";
import {ValidateUpcPipe} from "../../pipes/validate-tag/validate-upc";
import {ValidateSkuPipe} from "../../pipes/validate-tag/validate-sku";
import {ValidateRfidPipe} from "../../pipes/validate-tag/validate-rfid";

@IonicPage()
@Component({
  selector: 'page-replenishment',
  templateUrl: 'replenishment.html',
  providers: [FormatDataTypePipe, ValidateSkuPipe, ValidateUpcPipe, ValidateRfidPipe]
})
export class ReplenishmentPage {

  @ViewChild(Content) content: Content;
  @ViewChild('selectDepartment') selectDepartment: Select;

  private loadingMessage: Loading;
  private isDialogshowing: boolean = false;
  private isAlertShowing: boolean = false;

  //Pagination and Infinite Scroll
  private numberPage = 1;
  private qtyListItemsPerPage = 50;
  private totalReplenishmentRows = 0;
  private isInfiniteScrollOnBottom: boolean = false;
  private infiniteScrollNumber: number = 0;

  //Replenishment Configuration
  private searchPositionNumber: number;
  private StoreIDFilterLabel: string;

  //Replenishment Arrays
  private vizixReplenishmentArray: Array<ReplenishmentModel> = [];
  private vizixReplenishmentArrayToShow: Array<ReplenishmentModel> = [];

  //Column Names
  private column1: String;
  private column2: String;
  private column3: String;
  private column4: String;

  //Department Modal
  departmentName: string;
  @ViewChild('statusCardContainer') statusCardContainer: ElementRef;
  isModalOn: boolean = false;
  modal: any;

  private popoverDetails: Popover;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private statusBar: StatusBar,
              private loadingCtrl: LoadingController,
              private cdr: ChangeDetectorRef,
              private vizixService: VizixService,
              public modalController: ModalController,
              private replenishmentService: ReplenishmentService,
              private platform: Platform,
              private popoverCtrl: PopoverController,
              private _alertCtrl: AlertController,
              private translate: TranslateService) {

    this.searchPositionNumber = this.vizixService.configurationApp.ReplenishmentConfiguration.SearchPosition.value;
    this.StoreIDFilterLabel = this.vizixService.configurationApp.ReplenishmentConfiguration.StoreIDFilterLabel.value;
  }

  //Open department selector modal
  openPopover(myEvent) {
    this.content.scrollToTop();
    this.modal = this.modalController.create('PopoverSelectDepartmentPage', {
      'departmentList': this.replenishmentService.getDepartmentNamesWithReplenishmentTasks(),
      'departmentSelected': this.departmentName,
      'offsetTop': this.statusCardContainer.nativeElement.offsetTop,
      'offsetLeft': this.statusCardContainer.nativeElement.offsetLeft,
      'clientHeight': this.statusCardContainer.nativeElement.clientHeight
    }, {
      // enterAnimation : 'popover-pop-in',
      // leaveAnimation : 'popover-pop-out'
    });
    this.modal.present({ev: myEvent});
    this.isModalOn = true;
    this.modal.onDidDismiss(data => {
      this.showLoading();
      this.isModalOn = false;
      if (!isUndefined(data) && data != null) {
        if (this.departmentName != data) {
          this.departmentName = data;
        }
      }
      this.showReplenishmentTasks(true);
      this.dismissLoading();
    });
  }

  ionViewDidLoad() {
    this.departmentName = DEPARTMENT_NAME_ALL_VALUE;
    if (!this.isDialogshowing && !this.isAlertShowing) {
      this.showLoading();
      this.showReplenishmentTasks(this.departmentName);
    }
    this.cdr.detectChanges();
  }

  //go back to menu
  private goBack() {
    if (!this.isAlertShowing && !this.isDialogshowing) {
      if (this.isModalOn) {
        this.modal.dismiss();
      }
      this.navCtrl.pop().then();
    }
    else {
      if (this.popoverDetails) {
        this.popoverDetails.dismiss();
        this.popoverDetails = null;
      }
    }
  }

  //go to settings page
  goToAppConfig() {
    let returnNavParams = {};
    returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_REPLENISHMENT;
    this.navCtrl.push(AppConfigPage, returnNavParams);
  }

  ionViewWillEnter() {
    this.statusBar.styleLightContent();
    this.statusBar.backgroundColorByHexString(COLOR_REPLENISHENT_MODULE);
    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

  ionViewWillLeave() {
    this.cdr.detach();
  }

  //show loading dialog
  private showLoading() {
    if (!this.loadingMessage) {
      this.loadingMessage = this.loadingCtrl.create({
        content: this.translate.instant('replenishment.dialog.loading')
      });

      this.isDialogshowing = true;
      this.loadingMessage.present();
    }
  }

  //dismiss loading dialog
  private dismissLoading() {
    if (this.loadingMessage) {
      this.isDialogshowing = false;
      this.loadingMessage.dismiss();
      this.loadingMessage = null;
    }
  }

//Show replenishment tasks list when department id is selected
  showReplenishmentTasks(isDepartmentSelected) {
    setTimeout(() => {
      this.isInfiniteScrollOnBottom = false;
    }, 300);
    this.infiniteScrollNumber = 0;
    this.vizixReplenishmentArray = [];
    this.vizixReplenishmentArrayToShow = [];
    this.numberPage = 1;
    this.totalReplenishmentRows = 0;

    let array = this.replenishmentService.getReplenishmentList(this.departmentName);
    this.column1 = this.replenishmentService.column1;
    this.column2 = this.replenishmentService.column2;
    this.column3 = this.replenishmentService.column3;
    this.column4 = this.replenishmentService.column4;

    for (let tag of array) {
      this.vizixReplenishmentArray.push(new ReplenishmentModel(tag.department, tag.position1, tag.position2, tag.position3, tag.position4, tag.position5, tag.position6));
      this.totalReplenishmentRows += 1;
    }

    if (this.totalReplenishmentRows > 0) {
      if (this.totalReplenishmentRows <= this.qtyListItemsPerPage) {
        for (let i = 0; i < this.totalReplenishmentRows; i++) {
          this.vizixReplenishmentArrayToShow.push(new ReplenishmentModel(this.vizixReplenishmentArray[i].department, this.vizixReplenishmentArray[i].position1, this.vizixReplenishmentArray[i].position2, this.vizixReplenishmentArray[i].position3, this.vizixReplenishmentArray[i].position4, this.vizixReplenishmentArray[i].position5, this.vizixReplenishmentArray[i].position6));
        }
        setTimeout(() => {
          this.isInfiniteScrollOnBottom = true;
        }, 300);
      }
      else {
        for (let i = 0; i < this.qtyListItemsPerPage; i++) {
          this.vizixReplenishmentArrayToShow.push(new ReplenishmentModel(this.vizixReplenishmentArray[i].department, this.vizixReplenishmentArray[i].position1, this.vizixReplenishmentArray[i].position2, this.vizixReplenishmentArray[i].position3, this.vizixReplenishmentArray[i].position4, this.vizixReplenishmentArray[i].position5, this.vizixReplenishmentArray[i].position6));
        }
      }

      this.cdr.detectChanges();
      this.dismissLoading();
    }
    else {
      setTimeout(() => {
        this.isInfiniteScrollOnBottom = true;
        this.cdr.detectChanges();
      }, 500);
      this.showNoReplenishmentTasksError(isDepartmentSelected);
    }

    this.dismissLoading();
  }

  //Infinite Scroll --> fill VizixReplenishmentArray when it scrolls
  doInfinite(event: any) {
    this.setInfiteScrollStyle();
    if (this.qtyListItemsPerPage * this.numberPage <= this.vizixReplenishmentArray.length) {
      for (let i = (this.numberPage * this.qtyListItemsPerPage); i < ((this.numberPage + 1) * this.qtyListItemsPerPage); i++) {
        if (i < this.vizixReplenishmentArray.length && this.vizixReplenishmentArrayToShow.findIndex(item => item.position1 === this.vizixReplenishmentArray[i].position1) === -1) {
          this.vizixReplenishmentArrayToShow.push(new ReplenishmentModel(this.vizixReplenishmentArray[i].department, this.vizixReplenishmentArray[i].position1, this.vizixReplenishmentArray[i].position2, this.vizixReplenishmentArray[i].position3, this.vizixReplenishmentArray[i].position4, this.vizixReplenishmentArray[i].position5, this.vizixReplenishmentArray[i].position6));
        }
        else {
          break;
        }
      }
      this.numberPage++;
    }
    event.complete();
  }

  //Will set ngStlyle with isInfiniteScrollOnBottom flag in ion-infinite-scroll
  setInfiteScrollStyle() {
    this.infiniteScrollNumber++;
    let numberOfScrolls = Math.ceil(this.totalReplenishmentRows / this.qtyListItemsPerPage) - 1;
    this.isInfiniteScrollOnBottom = false;
    if (this.infiniteScrollNumber === 1) {
      this.isInfiniteScrollOnBottom = this.totalReplenishmentRows < this.qtyListItemsPerPage;
    } else {
      this.isInfiniteScrollOnBottom = this.infiniteScrollNumber >= numberOfScrolls;
    }
  }

  //will delete both replenishment arrays based on their index found and their position to search
  deleteItem(item, indexToDelete) {

    this.vizixReplenishmentArrayToShow.splice(indexToDelete, 1);
    this.vizixReplenishmentArray.splice(indexToDelete, 1);
    this.totalReplenishmentRows--;
    this.replenishmentService.DeleteTotallyItem(item, this.getDinamicPosition(item));
    this.cdr.detectChanges();
  }

  // based on vizix search position configuration,  this will return replenishment model position
  //ex:
  //if position to search = 1 => the position to filter will be position1 based on ReplenishmentModel
  private getDinamicPosition(item): string {
    return Object.keys(item)[this.searchPositionNumber];
  }

  //will replace prefixToSerach and send a value to find items page based on position to filter in array
  goToFindItem(item: ReplenishmentModel, slideItem?: any, event?: UIEvent) {
    if (event) {
      event.stopPropagation();
    }
    if (slideItem) {
      slideItem.close();
    }

    let returnNavParams = {};
    returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_REPLENISHMENT;
    returnNavParams[NAV_PARAM_AUTO_SEARCH] = item[this.getDinamicPosition(item)];
    this.navCtrl.push(FindItemPage, returnNavParams);
  }

  //Alert Confirm to delete Item
  public ShowAlertDeleteItem(item, indexToDelete, event: UIEvent, slideItem: any) {
    event.stopPropagation();
    let alert = this._alertCtrl.create({
      title: this.translate.instant('replenishment.alerts.delete_item.title'),
      subTitle: this.translate.instant('replenishment.alerts.delete_item.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('replenishment.alerts.delete_item.cancel'),
          handler: () => {
            this.isAlertShowing = false;
            slideItem.close();
          }
        },
        {
          text: this.translate.instant('replenishment.alerts.delete_item.ok'),
          handler: () => {
            this.deleteItem(item, indexToDelete);
            this.isAlertShowing = false;
          }
        }
      ]
    });
    this.isAlertShowing = true;
    alert.present();
  }

  //alert error no replenishment tasks
  private showNoReplenishmentTasksError(isDepartmentSelected) {
    let alert = this._alertCtrl.create({
      title: this.translate.instant('replenishment.alerts.no_replenishment_tasks.title'),
      subTitle: this.translate.instant('replenishment.alerts.no_replenishment_tasks.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('replenishment.alerts.no_replenishment_tasks.ok'),
          handler: () => {
            this.isAlertShowing = false;
            if (!isDepartmentSelected) {
              this.navCtrl.pop().then();
            }
          }
        }
      ]
    });

    this.isAlertShowing = true;
    alert.present();
  }

  //Alert to show entire column title
  alertHeader(column) {
    let alert = this._alertCtrl.create({
      title: this.translate.instant('replenishment.alerts.showColumnName.title'),
      subTitle: column,
      buttons: [{
        text: this.translate.instant('replenishment.alerts.showColumnName.ok'),
        handler: () => {
          this.isAlertShowing = false;
        }
      }]
    });
    this.isAlertShowing = true;
    alert.present();
  }

  initLoader(content: string, onWillDismiss?) {
    this.loadingMessage = this.loadingCtrl.create({
      content: this.translate.instant(content),
      enableBackdropDismiss: true
    });
    this.isAlertShowing = true;
    this.loadingMessage.present();
    this.loadingMessage.onWillDismiss(() => {
      this.isAlertShowing = false;
      if (onWillDismiss) {
        onWillDismiss();
      }
    });
  }

  openInfo(item: ReplenishmentModel, key: string) {
    const tag = item[key];
    this.initShowDetailsPopover(this.translate.instant("cycle_count.popovers.details.title"),
      tag, true, () => {
        this.goToFindItem(item);
      });
  }

  public goToDetails(item) {
    this.openInfo(item, this.getDinamicPosition(item));
  }

  initShowDetailsPopover(title: string, tag: string, showGeigerButton?: boolean, callback?) {
    // Initialize popoverDetails with the new product status list and the current status
    this.popoverDetails = this.popoverCtrl.create(PopoverDetailsPage,
      {
        title: title,
        tag: tag,
        showImage: true,
        showGeigerButton: false,
        findItemOption: true
      }, {showBackdrop: true, cssClass: 'details-popover'});
    this.popoverDetails.present(); // Without event {ev: event}, the popoverDetails shows in the middle
    this.isAlertShowing = true;
    this.popoverDetails.onWillDismiss(executeCallback => {
      this.isAlertShowing = false;
      if (callback && executeCallback) {
        callback();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/replenishment/replenishment.ts